/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './Donation-Actions';

const INITIAL_STATE = {
    error: '',
};

const addDonationItemReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.loadAddToDonationError().type:
            return {
                ...state,
                error: action.data.error,
            };
        case actions.addDonation().type:
            return { ...state, itemAdded: action.data.skus };
        default:
            return state;
    }
};

export default addDonationItemReducer;
